import properties from '../constants/properties';

const NZD = { symbol: '$', fieldSuffix: ' (NZD)', sectionSuffix: '(NZD)' };
const GBP = { symbol: '£', fieldSuffix: ' (£)', sectionSuffix: '(£)' };
const DEFAULT = { symbol: '$', fieldSuffix: ' ($)', sectionSuffix: '' };

const CurrencyUtils = {};

CurrencyUtils.getOnboardingCurrency = (organizationId) => {
  if (properties.UK_ONBOARDING_ORGS.includes(organizationId)) return GBP;
  if (properties.NZ_ONBOARDING_ORGS.includes(organizationId)) return NZD;
  return DEFAULT;
};

export default CurrencyUtils;
